import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse,
         HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { NbToastrService } from '@nebular/theme';
import { HelperService } from '../services/helper.service';

@Injectable()
export class InterceptedHttp implements HttpInterceptor {
    constructor(
        private router: Router,
        private auth: NbAuthService,
        private toster: NbToastrService,
        private helperService: HelperService,
    ) { }
    static requestCount: number = 0;
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.indexOf('auth/signin') === -1) {
            // Get the auth token from the service.
            let authToken = '';
            this.auth.getToken()
                .subscribe((atoken: NbAuthJWTToken) => {
                    // console.log('Token', atoken);
                    authToken = atoken['token'];
                });
            // Clone the request and set the new header in one step.
            const authReq = req.clone({ headers: req.headers.append('Authorization', 'Bearer ' + authToken) });
            InterceptedHttp.requestCount++;
            // send cloned request with header to the next handler.
            return next.handle(authReq)
                .pipe(
                    map((event: HttpEvent<any>) => {
                        if (event instanceof HttpResponse) {

                        }
                        return event;
                    }),
                    catchError((error: HttpErrorResponse) => {
                        if (error.status === 401) {
                            this.toster.danger('Session expired', 'Your Session has expired. Please sign in');
                            this.helperService.clearLocalStorage();
                            this.auth.logout('email');
                            this.router.navigate(['auth/signin']);
                        }
                        return throwError(error);
                    }));
        } else {
            const _req = req.clone({ setHeaders: { 'Content-Type': 'application/x-www-form-urlencoded' } });
            return next.handle(_req);
        }
    }



}
